module.exports = __webpack_public_path__ + "img/small-logo.08b55a16.svg";